import React from 'react';
import { Typography, Tabs, Tab } from '@mui/material';
import { infoText, tab, tabs } from './Login.sx';
import LoginForm from 'app/components/LoginForm';
import useLogin from 'app/pages/Authorization/Login/useLogin';
import CardLogin from 'app/components/Layouts/CardLogin';
const Login = () => {
  const { t, value, handleChange } = useLogin();

  return (
    <CardLogin>
      <Typography sx={infoText}>{t('login.welcome')}</Typography>
      <Tabs value={value} onChange={handleChange} sx={tabs}>
        <Tab sx={tab} label={'Email'} />
        <Tab sx={tab} label={'Asan İmza'} />
        {/*<Tab sx={tab} iconPosition="start" label="Google" />*/}
      </Tabs>
      <LoginForm tabNumber={value} />
    </CardLogin>
  );
};

export default Login;
